import { render, staticRenderFns } from "./ClockInWidget.vue?vue&type=template&id=4b8fb384&"
import script from "./ClockInWidget.vue?vue&type=script&lang=ts&"
export * from "./ClockInWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports